import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  Col,
  Row,
  Typography,
  notification,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { toggleNewDialog, setSelectedBuyer } from "../store/stateSlice";
import { putBuyer, getAllBuyer, postBuyer } from "../store/dataSlice";

const style = {
  padding: "0px 10px",
};

const BuyerForm = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(null);
  const [api, contextHolder] = notification.useNotification();
  const [form] = Form.useForm();

  const newDialog = useSelector((state) => state.buyer.state.openDialog);
  const selectedBuyer = useSelector((state) => state.buyer.state.selectedBuyer);

  const onDialogClose = () => {
    dispatch(toggleNewDialog(false));
    dispatch(setSelectedBuyer({}));
    form.resetFields();
  };

  useEffect(() => {
    if (selectedBuyer) {
      form.resetFields();
      form.setFieldsValue(selectedBuyer);
    } else {
      form.resetFields();
      form.setFieldsValue({
        buyer_name: "",
        buyer_mobile: "",
        buyer_address: "",
        buyer_account_no: "",
        buyer_ifsc_code: "",
        buyer_bank_name: "",
        remember: false,
      });
    }
  }, [selectedBuyer, form]);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const action =
        Object.values(selectedBuyer).length > 0
          ? await dispatch(
              putBuyer({ ...values, buyer_id: selectedBuyer.buyer_id })
            )
          : await dispatch(postBuyer(values));
      if (action.payload.status < 300) {
        api["success"]({
          message: "Success",
          description:
            Object.values(selectedBuyer).length > 0
              ? "Buyer Edited Successfully"
              : "Buyer Added Successfully",
        });
        setLoading(false);
        dispatch(toggleNewDialog(false));
        dispatch(getAllBuyer());
        form.resetFields();
      } else {
        api["error"]({
          message: "Error",
          description: action?.payload?.data?.message,
        });
        setLoading(false);
      }
    } catch (err) {}
  };

  return (
    <>
      <Modal title="" open={newDialog} onCancel={onDialogClose} footer={[]}>
        {contextHolder}
        <h2 className="text-2xl text-center mb-4">
          {Object.values(selectedBuyer).length > 0 ? "Edit Buyer" : "Add Buyer"}
        </h2>
        <Form
          form={form}
          initialValues={{
            buyer_name: "",
            buyer_mobile: "",
            buyer_address: "",
            buyer_account_no: "",
            buyer_ifsc_code: "",
            buyer_bank_name: "",
            remember: false,
          }}
          onFinish={onFinish}
          autoComplete="off">
          <Row>
            <Col span={12} style={style}>
              <Typography>Name</Typography>
              <Form.Item
                name="buyer_name"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
                className="gap-2"
                hasFeedback>
                <Input size="large" placeholder="Buyer Name" />
              </Form.Item>
            </Col>
            <Col span={12} style={style}>
              <Typography>Contact</Typography>
              <Form.Item
                name="buyer_mobile"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
                hasFeedback>
                <Input size="large" placeholder="Buyer Mobile" type="number" />
              </Form.Item>
            </Col>
            <Col span={12} style={style}>
              <Typography>Address</Typography>
              <Form.Item
                name="buyer_address"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
                hasFeedback>
                <Input size="large" placeholder="Buyer Address" />
              </Form.Item>
            </Col>
            <Col span={12} style={style}>
              <Typography>Account No.</Typography>
              <Form.Item
                name="buyer_account_no"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
                hasFeedback>
                <Input size="large" placeholder="Account Number" />
              </Form.Item>
            </Col>
            <Col span={12} style={style}>
              <Typography>IFSC</Typography>
              <Form.Item
                name="buyer_ifsc_code"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
                hasFeedback>
                <Input size="large" placeholder="IFSC Code" />
              </Form.Item>
            </Col>
            <Col span={12} style={style}>
              <Typography>Bank</Typography>
              <Form.Item
                name="buyer_bank_name"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
                hasFeedback>
                <Input size="large" placeholder="Bank Name" />
              </Form.Item>
            </Col>
          </Row>
          <div className="flex justify-end items-center gap-2 mt-5 ">
            <Button key="back" onClick={onDialogClose}>
              Cancel
            </Button>
            <Button
              key="submit"
              type="primary"
              className="btn"
              htmlType="submit"
              loading={loading}>
              {Object.values(selectedBuyer).length > 0 ? "Update" : "Submit"}
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default BuyerForm;
